import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import styled from 'styled-components'

function AnimeItem() {
    const {id} = useParams()

    //state
    const [anime, setAnime] = React.useState({})
    const [characters, setCharacters] = React.useState([])
    const [showMore, setShowMore] = React.useState(false)

    //destructure anime
    const {
        title, synopsis, 
        trailer,duration,aired, 
        season, images, rank, 
        score,scored_by, popularity, 
        status, rating, source } = anime

    //get anime based on id
    const getAnime = async (anime) => {
        const response = await fetch(`https://api.jikan.moe/v4/anime/${anime}`)
        const data = await response.json()
        setAnime(data.data)
    }

    //get characters
    const getCharacters = async (anime) => {
        const response = await fetch(`https://api.jikan.moe/v4/anime/${anime}/characters`)
        const data = await response.json()
        setCharacters(data.data)
        console.log(data.data)
    }


    //initial render
    useEffect(() => {
        getAnime(id)
        getCharacters(id)
    }, [])

    return (
        <AnimeItemStyled>
            <h1>{title}</h1>
            <div className="details">
                <div className="detail">
                    <div className="image">
                        <img src={images?.jpg.large_image_url} alt="" />
                    </div>
                    <div className="anime-details">
                        <p><span>Aired:</span><span>{aired?.string}</span></p>
                        <p><span>Rating:</span><span>{rating}</span></p>
                        <p><span>Rank:</span><span>{rank}</span></p>
                        <p><span>Score:</span><span>{score}</span></p>
                        <p><span>Scored By:</span><span>{scored_by}</span></p>
                        <p><span>Popularity:</span><span>{popularity}</span></p>
                        <p><span>Status:</span><span>{status}</span></p>
                        <p><span>Source:</span><span>{source}</span></p>
                        <p><span>Season:</span><span>{season}</span></p>
                        <p><span>Duration:</span><span>{duration}</span></p>
                    </div>
                </div>
                <p className="description">
                    {showMore ? synopsis : synopsis?.substring(0, 450) + '...'}
                    <button onClick={() => {
                        setShowMore(!showMore)
                    }}>{showMore ? 'Show Less': 'Read More'}</button>
                </p>
            </div>
            <h3 className="title">Trailer</h3>
            <div className="trailer-con">
                {trailer?.embed_url ? 
                    <iframe 
                        src={trailer?.embed_url} 
                        title="Inline Frame Example"
                        width="800"
                        height="450"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen>
                    </iframe> :
                    <h3>Trailer not available</h3>
                }
            </div>
            <h3 className="title">Characters</h3>
            <div className="characters">
                {characters?.map((character, index) => {
                    const {role} = character
                    const {images, name, mal_id} = character.character
                    return <Link to={`/character/${mal_id}`} key={index}>
                        <div className="character">
                            <img src={images?.jpg.image_url} alt="" />
                            <h4>{name}</h4>
                            <p>{role}</p>
                        </div>
                    </Link>
                })}
            </div>
        </AnimeItemStyled >
    )
}

const AnimeItemStyled = styled.div`
/* Default styles */
padding: 3rem 18rem;
background-color: #EDEDED;

h1 {
    display: inline-block;
    font-size: 3rem;
    margin-bottom: 1.5rem;
    cursor: pointer;
    background: linear-gradient( to right, #A855F7, #27AE60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: all .4s ease-in-out;
}

.title {
    display: inline-block;
    margin: 3rem 0;
    font-size: 2rem;
    cursor: pointer;
    background: linear-gradient( to right, #A855F7 23%, #27AE60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.description {
    margin-top: 2rem;
    color: #6c7983;
    line-height: 1.7rem;
}

.description button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: #27AE60;
    font-weight: 600;
}

.trailer-con {
    display: flex;
    justify-content: center;
    align-items: center;
}

.trailer-con iframe {
    outline: none;
    border: 5px solid #e5e7eb;
    padding: 1.5rem;
    border-radius: 10px;
    background-color: #FFFFFF;
}

.details {
    background-color: #fff;
    border-radius: 20px;
    padding: 2rem;
    border: 5px solid #e5e7eb;
}

.details .detail {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.details .detail img {
    border-radius: 7px;
}

.details .anime-details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.details .anime-details p {
    display: flex;
    gap: 1rem;
}

.details .anime-details p span:first-child {
    font-weight: 600;
    color: #454e56;
}

.characters {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 2rem;
    background-color: #fff;
    padding: 2rem;
    border-radius: 20px;
    border: 5px solid #e5e7eb;
}

.characters .character {
    padding: .4rem .6rem;
    border-radius: 7px;
    background-color: #EDEDED;
    transition: all .4s ease-in-out;
}

.characters .character img {
    width: 100%;
}

.characters .character h4 {
    padding: .5rem 0;
    color: #454e56;
}

.characters .character p {
    color: #27AE60;
}

.characters .character:hover {
    transform: translateY(-5px);
}

/* Media Query for smaller screens (e.g., tablets) */
@media screen and (max-width: 992px) {
    padding: 3rem 10rem; /* Adjust padding for medium screens */
    h1 {
        font-size: 2.5rem; /* Reduce font size for medium screens */
    }
    .title {
        font-size: 1.8rem; /* Reduce font size for medium screens */
    }
}

/* Media Query for smaller screens (e.g., smartphones) */
@media screen and (max-width: 576px) {
    padding: 2rem; /* Adjust padding for small screens */
    h1 {
        font-size: 2rem; /* Reduce font size for small screens */
        margin-bottom: 1rem;
    }
    .title {
        font-size: 1.5rem; /* Reduce font size for small screens */
        margin: 2rem 0;
    }
    .description {
        line-height: 1.5rem; /* Adjust line height for small screens */
    }
    .description button {
        font-size: 1rem; /* Reduce font size for small screens */
    }
    .details {
        padding: 1rem; /* Adjust padding for small screens */
    }
    .characters .character {
        padding: .2rem .4rem; /* Adjust padding for small screens */
    }
}

`;

export default AnimeItem